import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProblemSection() {
  return <Section background="cream" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-65">
          <Quote className="w-12 h-12 text-[#C9A227] mx-auto mb-8 opacity-50" data-id="element-66" />
          <h2 className="text-3xl md:text-5xl font-serif text-[#3D2314] mb-8 leading-tight" data-id="element-67">
            ¿Estamos perdiendo la capacidad de pensar profundamente?
          </h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-10" data-id="element-68"></div>
          <p className="text-xl md:text-2xl text-[#5C3D2E] leading-relaxed font-serif italic" data-id="element-69">
            "Hoy la educación se ha vuelto superficial y rápida. Pocas veces
            aprendemos cómo pensaban realmente los grandes genios de la
            historia. Sin modelos inspiradores, es difícil desarrollar
            pensamiento profundo y creatividad."
          </p>
        </motion.div>
      </div>
    </Section>;
}